export default __webpack_public_path__ + "static/media/cake-razer-connect.3359cff8.svg";